/*!
* @Author: leo
* @Date: 2019-12-24 16:44:00
* @Last Modified by: leo
* @Last Modified time: 2019-12-24 16:44:00
* @Instruduction: 路由权限控制
*/

import { Route } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from './router'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import settings from './settings'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect', '/callback']

router.beforeEach(async(to: Route, _: Route, next: any) => {
    // Start progress bar
    NProgress.start()

    // Determine whether the user has logged in
    if (UserModule.token) {
        if (to.path === '/login') {
            // If is logged in, redirect to the home page
            next({ path: '/' })
            NProgress.done()
        } else {
            // Check whether the user has obtained his permission roles
            if (UserModule.role === -1) {
                try {
                    // Note: roles must be a object array! such as: ['admin'] or ['developer', 'editor']
                    await UserModule.getUserInfo()
                    const role = UserModule.role
                    // Generate accessible routes map based on role
                    PermissionModule.GenerateRoutes(role)
                    // Dynamically add accessible routes
                    router.addRoutes(PermissionModule.dynamicRoutes)
                    // Hack: ensure addRoutes is complete
                    // Set the replace: true, so the navigation will not leave a history record
                    next({ path: to.redirectedFrom || to.fullPath, replace: true })
                } catch (err) {
                    // Remove token and redirect to login page
                    UserModule.resetUser()
                    next(`/login?redirect=${to.path}`)
                    NProgress.done()
                }
            } else {
                next()
            }
        }
    } else {
        // Has no token
        if (whiteList.indexOf(to.path) !== -1) {
            // In the free login whitelist, go directly
            next()
        } else {
            // Other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`)
            NProgress.done()
        }
    }
})
  
router.afterEach((to: Route) => {
    // Finish progress bar
    NProgress.done()

    // set page title
    document.title = `${to.meta.title} - ${settings.title}`
})
